import axios from '../../http'

class XBAddress {
  // xb获取城市数据
  getXBAddressMock() {
    const url = '/address.json'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBAddress;
